module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-to-up-6d50f8e332e308d378403276cf1c1a88.svg";